export default __webpack_public_path__ + "static/media/Dipta Chowdhury.806401ae.pdf";